import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { userHasMenu } from '../auth/menu-access';
import { MenuVisibilityService } from '../left-menu/menu-visibility.service';
import { NAV_ICONS, SVG_CLOSE, SVG_OPEN } from '../left-menu/left-menu.component';
import { ChatService, SupportMailService } from '../stokker/api';

interface TabItem {
  label: string;
  /** rövid felirat a sávban */
  short: string;
  link: string;
  icon: SafeHtml;
}

/** Fontossági sorrend: az első négy, amit a felhasználó láthat, kerül az alsó sávba. */
const TAB_CANDIDATES: { label: string; short: string; link: string }[] = [
  { label: 'Mai nap', short: 'Mai nap', link: '/mai-nap' },
  { label: 'Chat', short: 'Chat', link: '/chat' },
  { label: 'Rendelések', short: 'Rendelések', link: '/orders' },
  { label: 'Készlet', short: 'Készlet', link: '/inventory' },
  { label: 'Support', short: 'Support', link: '/support' },
  { label: 'Gyártás', short: 'Gyártás', link: '/gyartas' },
  { label: 'Munkaidő', short: 'Munkaidő', link: '/munkaido' },
  { label: 'Tracking', short: 'Tracking', link: '/tracking' },
  { label: 'Komponensek', short: 'Komponens', link: '/components' },
];

/**
 * Alsó navigációs sáv telefonon / álló tableten (≤ 900px): a négy legfontosabb látható oldal
 * + „Több" (a teljes menü fiókja). A jogosultságokat a bal menüvel azonos szabály szűri.
 */
@Component({
  selector: 'app-mobile-tab-bar',
  templateUrl: './mobile-tab-bar.component.html',
  styleUrl: './mobile-tab-bar.component.scss',
})
export class MobileTabBarComponent implements OnInit, OnDestroy {
  mailUnread = 0;
  chatUnread = 0;
  readonly moreIcon: SafeHtml;
  private readonly all: TabItem[];
  private subs: Subscription[] = [];

  constructor(
    private auth: AuthService,
    private menu: MenuVisibilityService,
    private supportMail: SupportMailService,
    private chat: ChatService,
    sanitizer: DomSanitizer,
  ) {
    const svg = (paths: string) => sanitizer.bypassSecurityTrustHtml(SVG_OPEN + paths + SVG_CLOSE);
    this.all = TAB_CANDIDATES.map((t) => ({ ...t, icon: svg(NAV_ICONS[t.label] || '') }));
    this.moreIcon = svg('<line x1="4" y1="7" x2="20" y2="7"></line><line x1="4" y1="12" x2="20" y2="12"></line><line x1="4" y1="17" x2="20" y2="17"></line>');
  }

  ngOnInit(): void {
    this.subs.push(
      this.supportMail.unread$.subscribe((count) => (this.mailUnread = count)),
      this.chat.unread$.subscribe((count) => (this.chatUnread = count)),
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  get tabs(): TabItem[] {
    return this.all.filter((t) => userHasMenu(this.auth.user, t.label)).slice(0, 4);
  }

  get menuOpen(): boolean {
    return this.menu.isNavOpened();
  }

  badgeOf(tab: TabItem): number {
    return tab.label === 'Support' ? this.mailUnread : tab.label === 'Chat' ? this.chatUnread : 0;
  }

  toggleMore(): void {
    this.menu.toggleNavVisibility();
  }

  closeMenu(): void {
    this.menu.closeNavigation();
  }
}
